export default __webpack_public_path__ + "static/media/logo.166f4a01.png";